export default __webpack_public_path__ + "fk-cp-zion/img/error-404_d700a7.png";